<script setup lang="ts">
  const props = defineProps({
    modelValue: { type: [String, Number, Boolean, Object, Array], required: true },
    helpText: { type: String, default: null },
    selectableItem: { type: Array, default: () => [] },
    itemTitle: { type: String, default: 'title' },
    itemValue: { type: String, default: 'value' },
    label: { type: String, default: 'Project to Import' }
  })

  const emit = defineEmits(['update:modelValue'])
</script>

<template>
  <v-select
    :items="props.selectableItem"
    :modelValue="props.modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    color="primary"
    clearable
    prepend-icon="mdi-briefcase-download"
    :item-title="props.itemTitle"
    :item-value="props.itemValue"
    :label="props.label"
  />
</template>

<style scoped></style>
